<template>
  <div class="guest-layout">
    <NavBar
        :isPublic="true"
    />
    <div class="router-wrapper"><router-view /></div>

  </div>
</template>

<script>
import NavBar from "@/components/layout/Navbar.vue";

export default {
  name: "GuestLayout",
  components: {
    NavBar,
  },
};
</script>
